"use client";

import { Header } from "@/app/(store)/_components/header";
import { cartAnalitica, storeAnalitica } from "@/app/(store)/_utils/events";

function HeaderSlot() {
  return (
    <Header
      actions={{
        whatsApp: {
          analiticaEvent: storeAnalitica.events.share.whatsappHeader,
        },
        cart: {
          analiticaEvent: () =>
            cartAnalitica.events.action.headerClicked(
              "Página inicial da Vitrine"
            ),
        },
      }}
    />
  );
}

export default HeaderSlot;
